/* eslint-disable @typescript-eslint/no-explicit-any */
import { getPropertyByPath, type PropertyPath } from 'src/app/utils/functions/get-property-by-path';

/**
 * Stores an object and provides getters to retrieve property values by path.
 * Path results are cached until the object changes.
 *
 * See *object-path* docs for more information about path lookup.
 * https://www.npmjs.com/package/object-path
 *
 * @deprecated use the object directly or if you need path resolution, use `getPropertyByPath` directly.
 */
export class ObjectStorage<T = any> {
  private readonly pathCache = new Map<PropertyPath, any>();

  public constructor(private internalStoredObject: T = {} as T) {}

  /**
   * Access current object state directly
   */
  public get data(): T {
    return this.internalStoredObject;
  }

  protected get storedObject(): T {
    return this.internalStoredObject;
  }

  protected set storedObject(obj: T) {
    this.pathCache.clear();
    this.internalStoredObject = obj;
  }

  /**
   * Returns a nested object property value by path with optional fallback
   */
  public get(): T;
  public get<V = any>(path: PropertyPath, fallback?: V): V | undefined;
  public get<V = any>(path?: PropertyPath, fallback?: V): T | V | undefined {
    if (!path) {
      return this.internalStoredObject ?? fallback;
    }
    return getPropertyByPath(this.internalStoredObject as object, path, fallback, this.pathCache) as V | undefined;
  }
}
